import { useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { DefaultSortTypesEnum, OptionKey } from '@/common/types';

import { RoleLevel } from '../../role.types';


const useRolesListParams = () => {
  const [sortBy, setSortBy] = useState<OptionKey>(DefaultSortTypesEnum.ASC);
  const [currentPermissions, setCurrentPermissions] = useState<OptionKey[]>([]);
  const [currentLevel, setCurrentLevel] = useState<RoleLevel>(RoleLevel.All);
  const [currentPartners, setCurrentPartners] = useState<OptionKey[]>([]);
  const { page, setPage, setPerPage, perPage, searchString, setSearchString } = usePaginationParams();

  return {
    sortBy,
    setSortBy,
    page,
    setPage,
    setPerPage,
    perPage,
    searchString,
    setSearchString,

    setCurrentPermissions,
    currentPermissions,

    setCurrentPartners,
    currentPartners,

    currentLevel,
    setCurrentLevel
  };
};

export default useRolesListParams;
